import Quill from "quill";

import { LINE_SEPARATOR } from "../util/constants.js";

const Delta = Quill.import("delta");
const QuillKeyboard = Quill.import("modules/keyboard");
const KEY_BINDINGS = {
  linebreak: {
    key: 13,
    shiftKey: true,
    handler: function shiftEnterHandler(range) {
      this.quill.history.cutoff();
      const delta = new Delta()
        .retain(range.index)
        .delete(range.length)
        .insert(LINE_SEPARATOR);
      this.quill.updateContents(delta, Quill.sources.USER);
      this.quill.history.cutoff();
      // Position cursor after inserted linebreak
      this.quill.setSelection(range.index + 1, Quill.sources.SILENT);
    }
  },
  "header backspace": {
    key: 8,
    format: ["header"],
    offset: 0,
    empty: true,
    handler: function revertHeader() {
      this.quill.format("header", false, Quill.sources.USER);
    }
  }
};

export class Keyboard extends QuillKeyboard {
  constructor(quill, options) {
    super(quill, {
      ...options,
      bindings: {
        ...KEY_BINDINGS,
        ...options.bindings
      }
    });
  }
}
